import * as React from 'react'

import { TButtonVariantProps } from '~ui/components/buttons/Button/buildButtonVariantProps'
import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge'

type TButtonProps = OmitSafe<PropsOf<typeof ButtonLarge>, 'onClick' | keyof TButtonVariantProps>

type TProps = RequiredChildren &
  TButtonProps &
  TButtonVariantProps & {
    onClick: PropsOf<typeof ButtonLarge>['onClick']
  }

/**
 * button of the modal footer with some predefined props
 */
export const ModalButton: React.FC<TProps> = ({ onClick, children, ...buttonProps }) => {
  return (
    <ButtonLarge {...buttonProps} onClick={onClick}>
      {children}
    </ButtonLarge>
  )
}
